import * as React from "react";
import { Link } from "gatsby";

//styles
import "./index.scss";

interface PageLogoPropType {
  color?: string;
  type?: string;
}
export const PageLogo: React.FC<PageLogoPropType> = ({ color = "white" }) => {
  return (
    <Link title="Inicio" className={`page-logo ${color}`} to="/">
      <h1>Astrid & Gastón</h1>
    </Link>
  );
};
